import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/quartile-calculator',
  component: () => import('../../routes/QuartileCalculator.svelte'),
  card: {
    id: 'quartile-calculator',
    title: 'Quartile Calculator',
    description: 'Calculate quartiles (Q1, Q2, Q3), IQR, outlier fences, and detect outliers using the exclusive method.',
    icon: 'bar_chart',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/quartile-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Quartile Calculator – Q1, Q2, Q3, IQR, and Outlier Detector',
    description: 'Free quartile calculator that computes Q1, median (Q2), Q3, IQR, lower and upper outlier fences, and identifies outliers in your dataset using the exclusive interpolation method.',
  },
};

export default meta;